<template lang="pug">
    DropDown.hzAutoComplete(ref="dropdown", @show="handleShow", :disabled="disabled")
        template(slot="dropHead")
            input.hzFormElement(ref="ipt", :name="name", v-model.trim="currentValue", type="text", @input="_handleInput($event)", autocomplete="off", :style="iptStyle", @keydown.down.prevent="navigateOptions('next')", @keydown.up.prevent="navigateOptions('prev')", @keydown.enter.prevent="handleKeyDownEnter", @keydown.esc.stop.prevent="$refs.dropdown.hide()", :disabled="disabled")
        div(slot="dropBody", ref="dropBody", v-show="filterItems && filterItems.length")
            ul.hzAutoCompleteUl
                template(v-for="(item, index) in filterItems")
                    li(@click="clickLi", :class="{hover: index === hoverIndex}") {{item}}
</template>

<script>
    import Keyupdown from './util/keyupdown'
    import DropDown from './dropdown'
    export default {
        name: 'hz-email',
        mixins: [Keyupdown],
        components: { DropDown },
        props: {
            value: String,
            items: null,
            name: null,
            iptStyle: null,
            disabled: { type: Boolean, default: false }
        },
        
        data() {
            return {
                currentValue: this.value,
                suffixArray: this.items || ['qq.com', '126.com', '163.com']
            }
        },
        
        computed: {
            filterItems() {
                if(!this.currentValue) {
                    return [];
                }
                const emailArray = this.currentValue.split("@");
                if(emailArray.length == 1){
                    return this.suffixArray.map(item => {
                        return this.currentValue + "@" + item;
                    })
                }else if(emailArray.length == 2){
                    const rs = [];
                    this.suffixArray.map(item => {
                        if(item.indexOf(emailArray[1]) == 0){
                            rs.push(emailArray[0] + "@" + item)
                        }
                    })
                    return rs;
                }
                return []
            },
            itemsLength() {
                return this.filterItems.length;
            },
        },
        watch: {
            itemsLength(val){
                if(val){
                    this.$refs.dropBody.parentNode && (this.$refs.dropBody.parentNode.style.display = 'block')
                }else{
                    this.$refs.dropBody.parentNode && (this.$refs.dropBody.parentNode.style.display = 'none')
                }
            },
            value(val){
                if(val != this.currentValue){
                    this.currentValue = val;
                }
            }
        },

        methods: {
            handleShow(){
                this.hoverIndex=-1;
                if(this.itemsLength){
                    this.$refs.dropBody.parentNode.style.display = 'block'
                }else{
                    this.$refs.dropBody.parentNode.style.display = 'none'
                }
            },
            handleKeyDownEnter(){
                this.selectHoveredOption();
                this.$refs.ipt.blur();
                this.$refs.dropdown.hide();
            },
            _handleInput(event) {
                var value = event.target.value;
                this.currentValue = value;
                this.$emit('input', this.currentValue);
            },
            
            clickLi(e) {
                let li = e.currentTarget;
                let value = li.innerText;
                this.currentValue = value;
                this.$refs.dropdown.hide();
                this.$emit('input', this.currentValue);
            }
        }
    }
</script>

<style lang="stylus">
    .hzAutoComplete
        display inline-block
        position relative
        &:focus
            outline none
        input 
            width 100%
    
    .hzAutoCompleteUl
        li
            white-space nowrap
            line-height 30px
            padding 0 25px 0 10px
            cursor pointer
            font-size 12px
            position relative
            font-weight 500
            &:hover
                background-color #f0f0f0
            &.hover 
                background-color #3993ef
                color #fff
                    
</style>
            



// WEBPACK FOOTER //
// src/email.vue